import { Banner, PositionNames } from '../Api'
import { PLL_IMAGE_URL } from '../Config/config'
import { ASG_TEAM_LOGO_IMAGES } from './team'

export const ASG_YEAR = 2025
export const ALL_STAR_SLUG = '2025_all_star_game'
export const WLL_ALL_STAR_SLUG = '2025_wll_all_star_game'
export const ALL_STAR_TICKET_LINK = `https://premierlacrosseleague.com/kansas-city?utm_source=pll_web&utm_medium=all_star_voting_page`
export const ALL_STAR_VOTING_START_DATE = 1750068000 //June 16th 2025
export const ALL_STAR_CLOSE_DATE = 1750737599 //June 23rd 2025
export const ASG_VOTE_TEAM_LIMIT = 8
export const ASG_TEAM_COLORS = {
  east: '#0011E4',
  west: '#FF0000',
  'team izzy': '#FFFFFF',
  'team north': '#00B1FF',
}

export const ALL_STAR_TEAM_RULES: { [key: string]: number } = {
  A: 2,
  M: 2,
  D: 2,
  FO: 1,
  G: 1,
}

export const ALL_STAR_POSITION_ORDER: { [key: string]: number } = {
  A: 1,
  M: 2,
  D: 3,
  FO: 4,
  G: 5,
}

export const ASG_POSITION_TABS: PositionNames[] = [
  'Attack',
  'Midfield',
  'Defense',
  'Faceoff',
  'Goalie',
]

const ASG_IMAGE_BASE_URL = `https://premierlacrosseleague.com/wp-content/uploads/2023`
export const ALL_STAR_IMAGES = {
  logo: `${PLL_IMAGE_URL}/2025/06/ASG_Primary.webp`,
  votingLogo: `${PLL_IMAGE_URL}/2025/06/ASG_Primary.webp`,
  teamOne: ASG_TEAM_LOGO_IMAGES[ASG_YEAR.toString()]['east'],
  teamTwo: ASG_TEAM_LOGO_IMAGES[ASG_YEAR.toString()]['west'],
  skills: `${PLL_IMAGE_URL}/2025/06/ASG_Primary.webp`,
  votingBanner: `https://premierlacrosseleague.com/wp-content/uploads/2024/06/24ASG_Banner.webp`,
  asgBanner: `https://premierlacrosseleague.com/wp-content/uploads/2024/06/24ASG_Banner.webp`,
  bg: `${ASG_IMAGE_BASE_URL}/06/background-asg-scaled.webp`,
  wllTeamOne: `https://img.premierlacrosseleague.com/Teams/2025/Logo/wll_asg_izzy.png`,
  wllTeamTwo: `https://img.premierlacrosseleague.com/Teams/2025/Logo/wll_asg_north.png`,
}

export const SHOW_SKILLS_CHALLENGE_ITEMS = false

export const ALL_STAR_BANNER: Banner = {
  id: 56789,
  sponsor: '',
  location: ['all-star'],
  topUrl: `https://premierlacrosseleague.com/wp-content/uploads/2025/06/pll_Asg_vote_web_Banner2.webp`,
  tags: ['all-star', 'all-star-vote'],
  topLink: '',
  leftSideUrl: '',
  rightSideUrl: '',
  secondaryMobile: '',
  startTime: 0, //June 16th 2025
  endTime: 1752220800, //July 11th 2025
}

export const ALL_STAR_VOTE_BANNER: Banner = {
  id: 56791,
  sponsor: '',
  location: ['all-star'],
  topUrl:
    'https://premierlacrosseleague.com/wp-content/uploads/2025/06/pll_Asg_vote_web_Banner2.webp',
  tags: ['all-star', 'all-star-vote'],
  topLink: '',
  leftSideUrl: '',
  rightSideUrl: '',
  secondaryMobile: '',
  startTime: 0, //June 16th 2025
  endTime: 1752220800, //July 11th 2025
}

export type ASGTeamIds = 'east' | 'west'
export type WLLASGTeamIds = 'team izzy' | 'team north'

export type AllStarTeamTab = {
  order: number
  name: string
  id: ASGTeamIds
  color: string
  img: string
  logo: string
}

export type WLLAllStarTeamTab = {
  order: number
  name: string
  id: WLLASGTeamIds
  color: string
  img: string
  logo: string
}

export const asgTeams: AllStarTeamTab[] = [
  {
    order: 0,
    name: 'Eastern Conference',
    id: 'east',
    color: ASG_TEAM_COLORS.east,
    img: ALL_STAR_IMAGES.teamOne,
    logo: '',
  },
  {
    order: 1,
    name: 'Western Conference',
    id: 'west',
    color: ASG_TEAM_COLORS.west,
    img: ALL_STAR_IMAGES.teamTwo,
    logo: '',
  },
]

export const wllAsgTeams: WLLAllStarTeamTab[] = [
  {
    order: 0,
    name: 'Team Izzy',
    id: 'team izzy',
    color: ASG_TEAM_COLORS['team izzy'],
    img: ALL_STAR_IMAGES.wllTeamOne,
    logo: '',
  },
  {
    order: 1,
    name: 'Team North',
    id: 'team north',
    color: ASG_TEAM_COLORS['team north'],
    img: ALL_STAR_IMAGES.wllTeamTwo,
    logo: '',
  },
]

// Roster configuration constants
export const ROSTER_TYPES = {
  STARTER: 'starter',
  ACTIVE: 'active',
  INJURED: 'injured',
} as const

export type RosterType = (typeof ROSTER_TYPES)[keyof typeof ROSTER_TYPES]

export const ROSTER_SECTIONS = {
  COACHES: 'coaches',
  STARTERS: 'starters',
  RESERVES: 'reserves',
  INJURED: 'injured',
  ROSTERS: 'rosters',
} as const

export type RosterSection = (typeof ROSTER_SECTIONS)[keyof typeof ROSTER_SECTIONS]

export const ROSTER_SECTION_CONFIG = {
  [ROSTER_SECTIONS.COACHES]: {
    title: 'Coaches',
    rosterType: null,
  },
  [ROSTER_SECTIONS.STARTERS]: {
    title: 'Starters',
    rosterType: ROSTER_TYPES.STARTER,
  },
  [ROSTER_SECTIONS.ROSTERS]: {
    title: 'Rosters',
    rosterType: null,
  },
  [ROSTER_SECTIONS.RESERVES]: {
    title: 'Reserves',
    rosterType: ROSTER_TYPES.ACTIVE,
  },
  [ROSTER_SECTIONS.INJURED]: {
    title: 'Injured',
    rosterType: ROSTER_TYPES.INJURED,
  },
} as const

export const TEAM_ROSTER_LAYOUT = {
  LEFT_COLUMN: [ROSTER_SECTIONS.STARTERS],
  RIGHT_COLUMN: [ROSTER_SECTIONS.RESERVES, ROSTER_SECTIONS.INJURED],
} as const

// Team tab configuration
export const TEAM_TAB_CONFIG = {
  DEFAULT_TEAM: 'east' as ASGTeamIds,
  DEFAULT_TAB_INDEX: 0,
  ANALYTICS_LOCATION: 'all_star_game_rosters',
} as const

export const TEAM_TAB_LABELS = {
  east: 'East',
  west: 'West',
} as const

// Team tab configuration
export const WLL_TEAM_TAB_CONFIG = {
  DEFAULT_TEAM: 'team izzy' as WLLASGTeamIds,
  DEFAULT_TAB_INDEX: 0,
  ANALYTICS_LOCATION: 'all_star_game_rosters',
} as const

export const WLL_TEAM_TAB_LABELS = {
  'team izzy': 'Izzy',
  'team north': 'North',
} as const

export const EAST_GRADIENT = `
  radial-gradient(circle at 25% 25%, rgba(0, 17, 228, 0.15) 0%, transparent 45%),
  radial-gradient(circle at 75% 75%, rgba(255, 0, 0, 0.15) 0%, transparent 45%),
  radial-gradient(circle at 50% 50%, rgba(255, 255, 255, 0.08) 0%, transparent 70%),
  linear-gradient(135deg, #0f172a 0%, #1e293b 30%, #334155 70%, #0f172a 100%)
`
export const WEST_GRADIENT = `
  radial-gradient(circle at 75% 25%, rgba(255, 0, 0, 0.25) 0%, transparent 50%),
  radial-gradient(circle at 25% 75%, rgba(0, 17, 228, 0.10) 0%, transparent 40%),
  radial-gradient(circle at 80% 60%, rgba(255, 0, 0, 0.18) 0%, transparent 35%),
  radial-gradient(circle at 50% 50%, rgba(255, 255, 255, 0.08) 0%, transparent 70%),
  linear-gradient(135deg, #0f172a 0%, #1e293b 30%, #334155 70%, #0f172a 100%)
`

export const returnASGCoach = (
  team: 'home' | 'away',
  position: 'head' | 'assistant'
): string => {
  if (team === 'home') {
    return position === 'head'
      ? 'Western Head Coach: Tim Soudan'
      : 'Western Assistant Coach: Jeremy Boltus'
  }
  return position === 'head'
    ? 'Eastern Head Coach: Brian Holman'
    : 'Eastern Assistant Coach: Louie DeDonatis'
}

export const returnWLLASGCoach = (
  team: 'home' | 'away',
  position: 'head' | 'assistant'
): string => {
  if (team === 'home') {
    return position === 'head'
      ? 'Head Coach: Laurie DeLuca'
      : 'Assistant Coach: Tracey Sullivan'
  }
  return position === 'head' ? 'Head Coach: Jen Adams' : 'Assistant Coach: Dana Dobbie'
}

export const ROSTER_DESCRIPTION = {
  PLL: `The 2025 Lexus PLL All-Star Game features an exhibition between the Eastern Conference All-Stars & Western Conference All-Stars.`,
  WLL: `The 2025 Lexus WLL All-Star Game features the first ever WLL All-Star Game between Team Izzy & Team North.`,
}
